import { Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { AlertComponent } from 'src/app/structure/alert/alert.component';
import { environment } from 'src/environments/environment';
import { InspectionService } from 'src/app/services/inspection.service';
declare var $: any;
import * as _ from 'lodash';
@Component({
  selector: 'app-inspectionlist',
  templateUrl: './inspectionlist.component.html',
  styleUrls: ['./inspectionlist.component.css']
})
export class InspectionlistComponent implements OnInit {

  public environmentSettings: any;

  @ViewChildren(DataTableDirective)
  dtElements: QueryList<DataTableDirective>;
  dtOptionsOfMasterDirector: DataTables.Settings = {};
  dtOptionsOfRegisterDirector: DataTables.Settings = {};
  registerDirectorList: any[];
  masterDirectorList: any[];
  FromDateModelInMasterDirector: any;
  ToDateModelInMasterDirector: any;
  dtTriggerMasterDirector: Subject<any> = new Subject();
  dtTriggerRegisterDirector: Subject<any> = new Subject();
  error: any = { isError: false, errorMessage: '' };
  futureToDate: NgbDateStruct;
  futureToDateTo: NgbDateStruct;
  futureFromDate: NgbDateStruct;
  response: boolean;
  deleteInspectionId: any;
  dateOfInspection: any;
  dateOfInspectionTo: any;
  nameOftheInspectedPerson: any;
  editInspectionId: any;
  isSearchDivVisible = false;
  constructor(private InspectionService: InspectionService, private router: Router, 
    private alert: AlertComponent, private activatedRoute: ActivatedRoute) {
    this.response = false;
  }

  ngOnInit() {

    this.environmentSettings = environment;
    let searchflag = localStorage.getItem('searchdireflag');

    this.dtOptionsOfRegisterDirector = {
      destroy: true,
      scrollY: "210px",
      scrollX: true,
      scrollCollapse: true,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 10,
      stateSave: true,
      stateDuration: -1,
      search: true,
      order: [0, 'asc'],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      columnDefs: [{ orderable: false, targets: [3] }],
      dom: 'lBfrtip',//'Bfrtip',
      buttons: [
        {
          text: '<i class="fa fa-files-o"></i> Export to Excel',
          className: 'btn btn-sm btn-warning export-btn',
          filename: 'Inspection List',
          title: 'Inspection List',
          extend: 'excel',
          exportOptions: {
            columns: [1, 2],
            format: {
              body: function ( data, row, column, node ) {
                  if(data.includes("+") || data.includes("@") || data.includes("=") || data.includes("|") || data.includes("!")){
                    if(data.match(/^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+[.]+[a-zA-Z0-9.-]+$/)){  return data }else{ return  "'" + data + "'"; }
                  }else{ return data }
                }
            }
          }
        }
      ]
    };

    this.getRegisterDirectorList();
  }
  add(){
    this.router.navigate(
      [{ outlets: { 'structure-outlet': ['inspection','add']  } }],
      { relativeTo: this.activatedRoute.parent });
  }
  toggleSearchDiv() {
    this.isSearchDivVisible = !this.isSearchDivVisible;
  }

  // loadDetailsById(directorId) {
  //   this.router.navigate(['/intern/edit/', directorId]);
  // }

  adjustdirectormasterTable() {
    var directorData = this.registerDirectorList;
    if (directorData.length) {
      this.registerDirectorList = [];
      $("#inspectionalTable").DataTable().destroy();
      this.registerDirectorList = directorData;
      this.dtTriggerMasterDirector.next();
      setTimeout(() => {
        $("#inspectionalTable").DataTable().columns.adjust().draw();
      }, 200);
    }
  }

  tabRegisterOfDirectorOnClickEvent() {
    setTimeout(() => {
      $("#inspectionalTable").DataTable().columns.adjust().draw();
    });
  }


  getRegisterDirectorList() {
    this.registerDirectorList = [];
    this.InspectionService.getRegisterDirector({ isSearch: false }).subscribe(registerList => {
      this.registerDirectorList = registerList.data;
      this.dtTriggerRegisterDirector.next();
    });
  }

  loadInspectionDataById(inspectionId) {
    this.router.navigate(
      [{ outlets: { 'structure-outlet': ['inspection','edit',inspectionId]  } }],
      { relativeTo: this.activatedRoute.parent });
    // this.router.navigate(['/inspection/edit/', inspectionId]);
  }

  confirmDelete(id) {
    this.deleteInspectionId = id;
    $("#deleteConfirm").modal('toggle');
  }
  generateOutput() {
    let companyId = JSON.parse(localStorage.getItem('companyDetails')).companyID;
    var object = {
      id: null,
      fromDate: this.dateOfInspection,
      toDate: this.dateOfInspectionTo,
      name: this.nameOftheInspectedPerson
    }
    this.InspectionService.generateInspectionDocument(object).subscribe(response => {
      if (response.status == 0) {
        this.alert.success(response.message);
        var self = this;
        setTimeout(function () {
          self.downloadDocument(companyId);
          setTimeout(function () {
            self.downloadPdfDocument(companyId);
          }, 1000);
        }, 1000);
      } else {
        this.alert.error(response.message);
      }
    })
  }

  downloadDocument(id) {
    this.InspectionService.downloadInspectionFile(id, 'Multi');
  }
  downloadPdfDocument(id) {
    this.InspectionService.downloadInspectionPdfFile(id, 'Multi');
  }

  deleteInspection() {
    this.InspectionService.removeInspectionDetails(this.deleteInspectionId)
      .subscribe(response => {
        if (response.status == 0) {
          this.alert.success(response.message);
          $("#inspectionalTable").DataTable().destroy();
          // $("#deleteConfirm").modal('toggle');
        } else {
          this.alert.error(response.message);
        }
        this.getRegisterDirectorList();

      });
  }

  setDate(date) {
    if (date != "" && date != null) {
      return date.month + "-" + date.day + "-" + date.year;
    }
    return null;
  }

  doAdvSearch() {
    this.response = true;

    var searchParam =
    {
      "nameOftheInspectedPerson": this.nameOftheInspectedPerson,
      'dateOfInspection': this.setDate(this.dateOfInspection),
      'dateOfInspectionTo': this.setDate(this.dateOfInspectionTo),
      'isSearch': true,
    };
    this.registerDirectorList = [];
    $("#inspectionalTable").DataTable().destroy();
    this.InspectionService.getRegisterDirector(searchParam).subscribe(registerList => {
      this.response = false;
      this.registerDirectorList = registerList.data;
      this.dtTriggerRegisterDirector.next();
    });
  }
  clearAdvSearch() {
    this.dateOfInspection = undefined;
    this.dateOfInspectionTo = undefined;
    this.nameOftheInspectedPerson = '';
    $("#inspectionalTable").DataTable().destroy();
    this.getRegisterDirectorList();
  }
}
